document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.product-form__submit').forEach((button) => {
    button.addEventListener('click', (event) => {
      const redirectUrl = button.getAttribute('data-redirect-url');
      if (redirectUrl) {
        event.preventDefault(); // Prevent default form submission
        window.location.href = redirectUrl; // Redirect to the URL
      }
    });
  });
});
